import { render } from "./StudyProblemsItemPortal.vue?vue&type=template&id=97db252a&scoped=true"
import script from "./StudyProblemsItemPortal.vue?vue&type=script&lang=js"
export * from "./StudyProblemsItemPortal.vue?vue&type=script&lang=js"

import "./StudyProblemsItemPortal.vue?vue&type=style&index=0&id=97db252a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97db252a"]])

export default __exports__